import { PropositionInterfaceType } from '../../api/proposition-interface-type.model';
import { UploadedDocument } from '../../api/uploaded-document.model';
import { Deserializable } from '../../deserializable';
import { FileDto } from '../file-dto.model';

export class UploadedDocumentDto implements Deserializable {
  public AgentId?: number;
  public AllFilesNames: string;
  public BranchUserId?: number;
  public CaseNumber: number;
  public Certified: boolean;
  public CurrentUserId: number;
  public DateUploaded: Date;
  public DirectCustomerId?: number;
  public DocumentCode: string;
  public DocumentName: string;
  public LastModifiedDate?: Date;
  public NumberOfDocumentsAlreadyUploaded: number;
  public PlaceholderId: number;
  public PlaceholderName: string;
  public PlaceholdersToReuseDocument: Array<number>;
  public PropositionInterfaceType: PropositionInterfaceType;
  public SamId: string;
  public StaffId?: number;
  public StatusCode: string;
  public UploadedDocument: UploadedDocument;
  public UploadedDocumentDataId?: number;
  public UploadedFiles: Array<FileDto>;

  public AllowMultiple: boolean;
  public AllowMultipleApplicants: boolean;

  constructor() {
    this.PlaceholdersToReuseDocument = [];
    this.UploadedFiles = [];
  }

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.PropositionInterfaceType = new PropositionInterfaceType().deserialize(input.PropositionInterfaceType);
    this.UploadedDocument = new UploadedDocument().deserialize(input.UploadedDocument);

    this.UploadedFiles = input.UploadedFiles
      ? input.UploadedFiles.map((fileDto: FileDto) => new FileDto().deserialize(fileDto))
      : [];

    return this;
  }
}
